module.exports = __webpack_public_path__ + "img/NATURGY.f13ec7b9.png";